export default {
  bgWhite: {
    background: '#fff'
  },
  block: {
    display: 'block'
  },
  displayNone: {
    display: 'none'
  },
  inlineBlock: {
    display: 'inline-block'
  },
  row: {
    width: '100%',
    textAlign: 'left',
    float: 'left'
  },
  column33: {
    width: '33%',
    textAlign: 'left',
    float: 'left'
  },
  column50: {
    width: '50%',
    textAlign: 'left',
    float: 'left'
  },
  column20: {
    width: '20%',
    textAlign: 'left',
    float: 'left'
  },
  column30: {
    width: '30%',
    textAlign: 'left',
    float: 'left'
  },
  column60: {
    width: '60%',
    textAlign: 'left',
    float: 'left'
  },
  column40: {
    width: '40%',
    textAlign: 'left',
    float: 'left'
  },
  column66: {
    width: '66%',
    textAlign: 'left',
    float: 'left'
  },
  alignRight: {
    textAlign: 'right'
  }
};
